import { setProAlertHandler } from '../billingService/billingService'

import { showProAlert } from './showProAlert'

let initialized = false

export const initBillingProAlertHandler = () => {
  if (initialized) return
  initialized = true

  setProAlertHandler(showProAlert)
}
